export enum AppRoute {
  HOME = "/",
  DASHBOARD = "/dashboard",
  LOGIN = "/login",
  SIGNUP = "/signup",
  ADD_BRAND = "/add-brand",
  BRAND_DETAILS = "/brand/:id",
  BRAND_FEATURES = "/brand/:brandId/features",
  SEO_PREVIEW = "/seo-preview/:brandId",
  AUTH_CALLBACK = "/auth/callback",
}
